module.exports = __webpack_public_path__ + "img/home-foot-bg-1_2x.57d16736.png";